import React, {useEffect, useState} from 'react'
import {QRCodeScanner, QRCodeScannerProps} from './QRCodeScanner'
import MessageDialogComponent from '../../../common/resident/MessageDialogComponent'
import {Messages} from '../../../Messages'

export const QRCodeScannerWithGate = (props: QRCodeScannerProps) => {
    const [isOpenPromptDialog, setIsOpenPromptDialog] = useState(false)
    const [isOpenDeniedDialog, setIsOpenDeniedDialog] = useState(false)
    const [isOpenNoDeviceDialog, setIsOpenNoDeviceDialog] = useState(false)
    const [openQRCodeScanner, setOpenQRCodeScanner] = useState<boolean>(false)

    const getCameraPermissionState = async () => {
        if (typeof navigator === 'undefined') {
            return 'unknown'
        }

        const devices = await navigator.mediaDevices.enumerateDevices()
        const hasDevice = devices.some(d => d.kind === 'videoinput')

        if (!hasDevice) {
            return 'noDevice'
        }

        if (!navigator.permissions.query) {
            return 'unknown'
        }

        try {
            const status = await navigator.permissions.query({name: 'camera' as any})
            return status.state
        } catch {
            return 'unknown'
        }
    }

    useEffect(() => {
        (async () => {
            const permissionState = await getCameraPermissionState()
            switch (permissionState) {
                case 'granted':
                    setOpenQRCodeScanner(true)
                    break
                case 'denied':
                    setIsOpenDeniedDialog(true)
                    break
                case 'noDevice':
                    setIsOpenNoDeviceDialog(true)
                    break
                case 'prompt':
                case 'unknown':
                    setIsOpenPromptDialog(true)
                    break
            }
        })()
    }, [])

    const handleOpenPromptDialogOKButtonClick = () => {
        setIsOpenPromptDialog(false)
        setOpenQRCodeScanner(true)
    }

    const handleOpenDeniedDialogOKButtonClick = () => {
        setIsOpenDeniedDialog(false)
        props.onClose()
    }

    const handleOpenNoDeviceDialogOKButtonClick = () => {
        setIsOpenDeniedDialog(false)
        props.onClose()
    }

    return <>
        <MessageDialogComponent
            open={isOpenPromptDialog}
            params={{
                title: '確認',
                errorLevel: Messages.WOPCC0002.errorLevel,
                message: Messages.WOPCC0002.toString(),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: handleOpenPromptDialogOKButtonClick,
                    },
                ],
            }}
        />
        <MessageDialogComponent
            open={isOpenDeniedDialog}
            params={{
                title: '確認',
                errorLevel: Messages.WOPCC0003.errorLevel,
                message: Messages.WOPCC0003.toString(),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: handleOpenDeniedDialogOKButtonClick,
                    },
                ],
            }}
        />
        <MessageDialogComponent
            open={isOpenNoDeviceDialog}
            params={{
                title: '確認',
                errorLevel: Messages.WOPCC0004.errorLevel,
                message: Messages.WOPCC0004.toString(),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: handleOpenNoDeviceDialogOKButtonClick,
                    },
                ],
            }}
        />
        {openQRCodeScanner &&
            <QRCodeScanner
                {...props}
            />
        }
    </>
}
